import { render, staticRenderFns } from "./AccessLimitComponent.vue?vue&type=template&id=0a7a6e02&"
import script from "./AccessLimitComponent.vue?vue&type=script&lang=js&"
export * from "./AccessLimitComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports